import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const resizeObserverMessagePattern = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i;

window.addEventListener('error', (event) => {
  if (resizeObserverMessagePattern.test(event.message || '')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reasonMessage = event?.reason?.message || String(event?.reason || '');
  if (resizeObserverMessagePattern.test(reasonMessage)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
